import BaseModule from '@/store/baseModule';
import { makeListRequest } from '@/business/apiTreatment/request/makeQueryParams';
import BaseModulePlugins from '@/store/baseModule/plugins';
import BaseService from '@/services/services/tools/baseService';
import BaseAPI from '@/services/api/internal/tools/baseAPI';

export default (store) => {
  store.registerModule(
    ['actions', 'units'],
    new BaseModule({
      serviceAPI: new BaseService({
        api: new BaseAPI({
          url: `${process.env.MYPREDITY_BASE_URI}/units`,
        }),
        retry: { nbLeft: 3, timeout: 2000 },
      }),
      makeQueryParams: makeListRequest({}),
    })
  );
  const basePlugin = new BaseModulePlugins({
    module: 'actions/units',
    store,
  });
  basePlugin.onInit(() => {
    store.dispatch('actions/units/setItemsPageSize', 3);
  });
};
